import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'

const ModalAddEditIkanTangkapan = ({ showIkanTangkap, handleCloseIkanTangkap, dataPpmKapal, dataIkan, listDataIkan, setListDataIkan, isEdit }) => {

    useEffect(() => {
        if (!dataIkan) return
        const fetchAllData = () => {
            try {
                setValueNamaIkan(dataIkan.namaIkan)
                const bentukOpt = [{ value: '1', label: 'Segar' }, { value: '2', label: 'Beku' }]
                setValueBentukOpt(bentukOpt.find(opt => opt.value === dataIkan.bentuk))
                setValueNetto(dataIkan.netto)
                setValueSuhu(dataIkan.suhu)
                setValueSuhuPalka(dataIkan.suhuPalka)
                setValueNilaiOrganoleptik(dataIkan.nilaiOrganoleptik)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [dataIkan])

    const [valueNamaIkan, setValueNamaIkan] = useState(null)
    const onChangeNamaIkan = e => {
        setValueNamaIkan(e.target.value)
    }
    const [valueBentukOpt, setValueBentukOpt] = useState(null)
    async function loadOptionBentuk(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Segar'
            },
            {
                value: '2',
                label: 'Beku'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeBentukOpt = e => {
        setValueBentukOpt(e)
    }

    const [valueNetto, setValueNetto] = useState(null)
    const onChangeNetto = e => {
        setValueNetto(e.target.value)
    }
    const [valueSuhu, setValueSuhu] = useState(null)
    const onChangeSuhu = e => {
        setValueSuhu(e.target.value)
    }
    const [valueSuhuPalka, setValueSuhuPalka] = useState(null)
    const onChangeSuhuPalka = e => {
        setValueSuhuPalka(e.target.value)
    }
    const [valueNilaiOrganoleptik, setValueNilaiOrganoleptik] = useState(null)
    const onChangeNilaiOrganoleptik = e => {
        setValueNilaiOrganoleptik(e.target.value)
    }

    const handleClickSimpan = () => {
        const jsonIkan = {
            ...dataIkan,
            // trPpmKapalIkanPK: {
            //     nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
            // },
            namaIkan: valueNamaIkan,
            bentuk: valueBentukOpt.value,
            netto: valueNetto,
            suhu: valueSuhu,
            suhuPalka: valueSuhuPalka,
            nilaiOrganoleptik: valueNilaiOrganoleptik,
            createdBy: localStorage.getItem("userId"),
            createdDate: new Date()
        }
        setListDataIkan(prevList => {
            const index = prevList.findIndex(item => item.trPpmKapalIkanPK.nomorAjuKapal === dataPpmKapal.nomorAjuKapal && item.namaIkan === valueNamaIkan )

            let newList
            if (index !== -1) {
                newList = [...prevList]
                newList[index] = {...jsonIkan}
                // return updatedList
            } else {
                // return [...prevList, jsonIkan]
                newList = [...prevList, jsonIkan]
            }

            return newList.map((item, idx) => ({...item, trPpmKapalIkanPK: {nomorAjuKapal: dataPpmKapal.nomorAjuKapal, seri : idx + 1}}))
        })
        handleClickClose()
    }

    const handleClickClose = () => {
        handleCloseIkanTangkap()
    }
    return (
        <>
            <Modal
                show={showIkanTangkap}
                onHide={handleCloseIkanTangkap}
                size='md'
                centered
            >
                <Modal.Header closeButton><h6>Data Ikan Tangkapan</h6></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Ikan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Jenis (Nama) Ikan " className="form-control-sm" value={valueNamaIkan} onChange={onChangeNamaIkan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Bentuk</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionBentuk}
                                            value={valueBentukOpt}
                                            getOptionValue={(option) => option.value}
                                            getOptionLabel={(option) => option.label}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeBentukOpt}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Berat (kg)</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Berat " className="form-control-sm" value={valueNetto} onChange={onChangeNetto} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Suhu (celcius)</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Suhu " className="form-control-sm" value={valueSuhu} onChange={onChangeSuhu} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Suhu Palka (celcius)</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Suhu Palka" className="form-control-sm" value={valueSuhuPalka} onChange={onChangeSuhuPalka} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nilai Organoleptik</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nilai Organo" className="form-control-sm" value={valueNilaiOrganoleptik} onChange={onChangeNilaiOrganoleptik} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalAddEditIkanTangkapan